// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"row_wrapper__2TizR"};